import { defineStore } from "pinia";
import api from "@/services/api";

export const useNotificationStore = defineStore("notification", {
    state: () => ({
        notificationCount: 0,
        notificationSummary: [],
        loading: false,
    }),

    actions: {
        async fetchNotificationCount(date = null) {
            try {
                const response = await api.get(`/notification/summary`, {
                    params: date ? { date } : {},
                });
                
                this.notificationSummary = response.data.data;
                
                this.notificationCount = Object.values(this.notificationSummary).reduce((sum, item) => sum + item, 0);
            } catch (error) {
                console.error("Error fetching notification count:", error);
            } finally {
                this.loading = false;
            }
        },
    },
});